<template>
  <div>
    <template v-if="value.eventType === eventTypes.departure">
      <flight-info-departure :value="value.flight" />
    </template>
    <template v-if="value.eventType === eventTypes.arrival">
      <flight-info-arrival :value="value.flight" />
    </template>
    <v-divider />
    <flight-info-ac :value="value.flight" />
    <v-divider />
    <template v-if="value.flight.pax">
      <flight-info-pax :value="value.flight" />
      <v-divider />
    </template>
    <flight-info-state :value="value.flight" />
  </div>
</template>

<script>
  import FlightInfoDeparture from '@/components/FlightInfoDeparture'
  import FlightInfoArrival from '@/components/FlightInfoArrival'
  import FlightInfoPax from '@/components/FlightInfoPax'
  import FlightInfoState from '@/components/FlightInfoState'
  import FlightInfoAc from '@/components/FlightInfoAc'
  import { eventTypes } from '../config/eventTypes'

  export default {
    name: 'FlightEventInfo',
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    data: () => ({}),
    components: {
      FlightInfoDeparture,
      FlightInfoArrival,
      FlightInfoPax,
      FlightInfoState,
      FlightInfoAc
    },
    methods: {},
    computed: {
      eventTypes() {
        return eventTypes
      }
    }
  }
</script>
